import { EChatAction } from '../../types/chatActionModal';
import { ITypedReduxAction } from '../../types/redux/actionType';

export enum EChatActionModalActionTypes {
  Open = 'chatActionModal/show',
  Close = 'chatActionModal/hide',
}

export type TChatActionModalShowPayload = {
  text: string;
  buttonText: string;
  chatAction: EChatAction;
};

export type TChatActionModalActions =
  | ITypedReduxAction<EChatActionModalActionTypes.Open, TChatActionModalShowPayload>
  | ITypedReduxAction<EChatActionModalActionTypes.Close, void>;
